/**
 * Legend for the obligation Pflichtklasse (tier 1–4) — an expandable info
 * box explaining what each class means and who inspects. Tier is the
 * regulated object's class; it drives inspector qualification and review
 * stringency.
 */

import { useId, useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronUp, Info } from "lucide-react";

import { Button } from "@/components/ui/button";

const TIERS = [1, 2, 3, 4];

export default function PflichtklasseLegend() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const contentId = useId();

  return (
    <div className="flex min-w-0 flex-col">
      <div className="flex flex-wrap">
        <Button
          variant="ghost"
          size="sm"
          className="gap-2 px-2 max-sm:w-full max-sm:justify-start"
          aria-expanded={open}
          aria-controls={contentId}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? (
            <ChevronUp aria-hidden className="h-4 w-4" />
          ) : (
            <Info aria-hidden className="h-4 w-4" />
          )}
          {t("operatorResponsibilityPanel.tierLegend.title")}
        </Button>
      </div>
      {open ? (
        <div
          id={contentId}
          className="mt-2 flex min-w-0 max-w-[900px] flex-col gap-2 rounded-md border p-3 text-sm leading-relaxed"
        >
          {TIERS.map((tier) => (
            <p key={tier} className="min-w-0 break-words">
              <b>{t("operatorResponsibilityPanel.tierLegend.tierLabel", { tier })}</b>{" "}
              {t(`operatorResponsibilityPanel.tierLegend.${tier}`)}
            </p>
          ))}
        </div>
      ) : null}
    </div>
  );
}
